/**
 * Currency utility functions for Indian Rupee formatting
 */

export const formatCurrencyINR = (amount, options = {}) => {
  const {
    showDecimals = false,
    compact = false,
    showSymbol = true
  } = options;

  if (amount === null || amount === undefined || isNaN(amount)) {
    return showSymbol ? '₹0' : '0';
  }

  const numericAmount = parseFloat(amount);

  if (compact && numericAmount >= 10000000) {
    // Format in crores
    const crores = numericAmount / 10000000;
    const formatted = crores.toFixed(crores >= 10 ? 0 : 1);
    return showSymbol ? `₹${formatted}Cr` : `${formatted}Cr`;
  } else if (compact && numericAmount >= 100000) {
    // Format in lakhs
    const lakhs = numericAmount / 100000;
    const formatted = lakhs.toFixed(lakhs >= 10 ? 0 : 1);
    return showSymbol ? `₹${formatted}L` : `${formatted}L`;
  }

  // Standard formatting
  const formatter = new Intl.NumberFormat('en-IN', {
    style: 'currency',
    currency: 'INR',
    minimumFractionDigits: showDecimals ? 2 : 0,
    maximumFractionDigits: showDecimals ? 2 : 0
  });

  let formatted = formatter.format(numericAmount);
  
  if (!showSymbol) {
    formatted = formatted.replace('₹', '').trim();
  }

  return formatted;
};

export const parseCurrencyINR = (currencyString) => {
  if (!currencyString) return 0;
  
  // Remove currency symbol and formatting
  const cleaned = currencyString
    .replace(/₹/g, '')
    .replace(/[,\s]/g, '')
    .trim();
  
  // Handle crores and lakhs
  if (cleaned.toLowerCase().includes('cr')) {
    const value = parseFloat(cleaned.replace(/cr/gi, ''));
    return value * 10000000;
  } else if (cleaned.toLowerCase().includes('l')) {
    const value = parseFloat(cleaned.replace(/l/gi, ''));
    return value * 100000;
  }
  
  return parseFloat(cleaned) || 0;
};

// Export default formatCurrencyINR for easier imports
export default formatCurrencyINR;